export const PaymentDropdown = (data) => {
    return {
      type: 'PaymentDropdown',
      payload: data
    }
}